export var chartDefaults = {
  fontFamily: 'Lato, Arial, sans-serif',
  fontSize: 12
};